var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAmazonS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3243 8.328L4.125 9.92796V38.0087L7.3243 39.5993L7.34353 39.5762V8.35003L7.3243 8.328Z",
    fill: "#8C3123"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4464 35.5236L7.32434 39.5993V8.328L24.4464 12.3149V35.5236Z",
    fill: "#E05243"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7177 29.1427L23.9803 30.0673L24.0259 29.9621L24.0667 18.0532L23.9803 17.9601L16.7177 18.8713V29.1427Z",
    fill: "#8C3123"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9803 35.5693L40.6363 39.608L40.6625 39.5663L40.662 8.35593L40.6356 8.328L23.9803 12.3606V35.5693Z",
    fill: "#8C3123"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.245 29.1427L23.9803 30.0673V17.9601L31.245 18.8713V29.1427Z",
    fill: "#E05243"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2449 13.904L23.9803 15.228L16.7177 13.904L23.9711 12.0028L31.2449 13.904Z",
    fill: "#5E1F18"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2449 34.0966L23.9803 32.7639L16.7177 34.0966L23.9714 36.1214L31.2449 34.0966Z",
    fill: "#F2B0A9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7177 13.904L23.9803 12.1067L24.0391 12.0886V0.0485541L23.9803 0L16.7177 3.63194V13.904Z",
    fill: "#8C3123"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.245 13.904L23.9803 12.1067V0L31.245 3.63194V13.904Z",
    fill: "#E05243"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9803 48L16.7169 44.3693V34.0974L23.9803 35.8941L24.0872 36.0155L24.0582 47.7904L23.9803 48Z",
    fill: "#8C3123"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9803 48L31.2444 44.3693V34.0974L23.9803 35.8941V48Z",
    fill: "#E05243"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6364 8.328L43.837 9.92796V38.0087L40.6364 39.608V8.328Z",
    fill: "#E05243"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAmazonS3);
export default __webpack_public_path__ + "static/media/ic-amazon-s3.4cb69f60d339a4ade744add142d6ba18.svg";
export { ForwardRef as ReactComponent };